import { render, staticRenderFns } from "./SPGChat.vue?vue&type=template&id=ae988736&scoped=true"
import script from "./SPGChat.vue?vue&type=script&lang=js"
export * from "./SPGChat.vue?vue&type=script&lang=js"
import style0 from "./SPGChat.vue?vue&type=style&index=0&id=ae988736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae988736",
  null
  
)

export default component.exports